function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun_profile_2072928");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  transform: "translate(-25.000000, -219.000000)",
  fill: "#ffffff",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_profile_2072928",
  transform: "translate(25.000000, 219.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5238095,0 C20.952381,0 27,6.04761905 27,13.5238095 C27,20.952381 20.952381,27 13.5238095,27 C6.04761905,27 0,20.952381 0,13.5238095 C0,6.04761905 6.04761905,0 13.5238095,0 Z M13.5238095,6.61904762 C16.3333333,6.61904762 18.6190476,8.9047619 18.6190476,11.7142857 C18.6190476,13.6190476 17.5714286,15.2857143 16.047619,16.1428571 C18.8095238,17.047619 20.952381,19.3809524 21.5714286,22.2380952 C23.952381,20.0952381 25.4285714,16.952381 25.4285714,13.5238095 C25.4285714,6.95238095 20.0952381,1.61904762 13.5238095,1.61904762 C6.95238095,1.61904762 1.61904762,6.95238095 1.61904762,13.5238095 C1.61904762,16.952381 3.0952381,20.0952381 5.42857143,22.2380952 C6.04761905,19.3809524 8.19047619,17.047619 10.952381,16.1428571 C9.42857143,15.2857143 8.38095238,13.6190476 8.38095238,11.7142857 C8.38095238,8.9047619 10.7142857,6.61904762 13.5238095,6.61904762 Z M20.1428571,23.3809524 L20.1428571,23.3333333 C19.8095238,19.952381 16.9047619,17.3809524 13.5238095,17.3809524 C10.0952381,17.3809524 7.23809524,19.952381 6.9047619,23.3333333 L6.9047619,23.3809524 C8.76190476,24.6666667 11.047619,25.4285714 13.5238095,25.4285714 C15.952381,25.4285714 18.2380952,24.6666667 20.1428571,23.3809524 Z M13.5238095,8.23809524 C11.5714286,8.23809524 10,9.80952381 10,11.7142857 C10,13.6666667 11.5714286,15.2380952 13.5238095,15.2380952 C15.4285714,15.2380952 17,13.6666667 17,11.7142857 C17,9.80952381 15.4285714,8.23809524 13.5238095,8.23809524 Z",
  id: "Shape"
}))));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Profile.0f29e725.svg";
export { ForwardRef as ReactComponent };